import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { clone, isEmpty, isNil } from "ramda";
import { toast } from "react-toastify";
import { getMuiTheme } from "../../utils/utils";
import palette from "../../../config/colorPalette";
import { Box, Button, MenuItem, TextField } from "@mui/material";
import { handleInterMeasurementTime, offsetPolygonPerSegment, updateData } from "./utils/utils";

import { ErrorText } from "./styled";
import LoadingButton from "@mui/lab/LoadingButton";
import { getAssetsDataAction } from "../../redux/assetsSlice";
import { getConfigDataAction } from "../../redux/configSlice";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { getPointsByAssets, pingIpAddress } from "../../api";
import { ThemeProvider } from "styled-components";
import { styled } from "@mui/material/styles";
import ChannelInfo from "./components/channelInfo";
import MeasurementInfo from "./components/measurementInfo";

const Configuration = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const theme = useMemo(() => getMuiTheme(), []);

  const assets = useSelector((state) => state.assetsData);
  const currentConfig = useSelector((state) => state.configData.data);
  const currentUser = useSelector((state) => state.userData.data);

  const [selectedAsset, setSelectedAsset] = useState(null);
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const [selectedEquipmentID, setSelectedEquipmentID] = useState(null);
  const [assetSensors, setAssetSensors] = useState(null);
  const [channelsSensorsIDs, setchannelSensorsIDs] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [dataReloadTime, setDataReloadTime] = useState(0);
  const [alertTimeRange, setAlertTimeRange] = useState(0);
  const [equipments, setEquipments] = useState([]);

  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingPing, setLoadingPing] = useState(false);
  const disabled = useMemo(() => !isEmpty(errors) || loading, [errors, loading]);
  const disabledPing = useMemo(
    () => (!isEmpty(errors) && !isNil(errors[selectedEquipmentID + "_IP"])) || loadingPing,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [errors, loadingPing],
  );
  const equipmentTypes = useSelector((state) => state.equipmentTypeData.data);
  const [objectMeasures, setObjectMeasures] = useState(null);

  const [subToggle, setSubToggle] = useState([]);
  const [channelDataToggle, setChannelDataToggle] = useState();
  const [channelDataToggle2, setChannelDataToggle2] = useState();
  const [zoneToggle, setZoneToggle] = useState([]);

  const [realState, setRealState] = useState(true);
  const [equipmentInterMeasurement, setEquipmentInterMeasurement] = useState();
  const [polylines, setPolylines] = useState([]);
  const BootstrapButton = styled(Button)({
    marginBottom: "5%",
    border: "1px solid",
    lineHeight: 1.5,
    backgroundColor: palette.primary,
    borderColor: palette.secondary,
    "&:hover": {
      backgroundColor: palette.link,
      borderColor: palette.secondary,
      boxShadow: "none",
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: palette.link,
      borderColor: palette.secondary,
    },
    "&:focus": {
      boxShadow: "0 0 0 0.2rem rgba(134,26,33,.5)",
    },
  });

  useEffect(() => {
    if (!isNil(equipmentTypes)) {
      const newData = equipmentTypes.map((item) => {
        const measures = [];
        item.config?.measurands.forEach((measure, index) => {
          if (measure.origin === "measure") {
            measures.push(measure.ref);
          }
        });

        const newEntry = { name: item.name, measures: measures };
        return newEntry;
      });
      setObjectMeasures(newData);
    }
  }, [equipmentTypes]);

  useMemo(() => {
    async function getAssetInfo() {
      if (!isNil(assets.data) && !isEmpty(assets.data) && !isNil(currentConfig)) {
        setSelectedAsset(assets.data[0]);
        setAlertTimeRange(assets.data[0].alertTimeRange / 60);
        setEquipments(assets.data[0].equipments ?? []);
        setSelectedEquipment(assets.data[0].equipments[0]);
        setSelectedEquipmentID(assets.data[0].equipments[0].equipmentID);
        setDataReloadTime(currentConfig.loadTime);
        const response = await getPointsByAssets(assets.data[0].name);
        setPolylines(response.data.data);
        if (!isNil(assets.data[0].sensors)) {
          const assetSensIDs = [];
          for (let index = 0; index < assets.data[0].config.additionalSensors.length; index++) {
            assetSensIDs.push(assets.data[0].config.additionalSensors[index].sensor_ID);
          }
          setAssetSensors(assetSensIDs);
        }
      }
    }
    getAssetInfo();
  }, [assets, currentConfig]);

  useEffect(() => {
    if (!isNil(selectedEquipment) && !isNil(objectMeasures) && realState) {
      setchannelSensorsIDs(selectedEquipment.channelsSensorsIDs);

      const newErrors = {};
      const suma = !isNil(selectedEquipment.channels)
        ? selectedEquipment.channels.reduce(
            (acumulador, canal) => acumulador + (parseFloat(canal.measurement.measurementTime) || 0),
            0,
          )
        : 0;
      const falseStateChannels = selectedEquipment.channels.reduce((indices, valor, indice) => {
        if (!valor.state) {
          indices.push(indice);
        }
        return indices;
      }, []);
      let auxequipmentInterMeasurement = suma;
      for (let indexState = 0; indexState < falseStateChannels.length; indexState++) {
        if (
          !isNil(selectedEquipment.channels[falseStateChannels[indexState]].measurement) &&
          !isNil(selectedEquipment.channels[falseStateChannels[indexState]].measurement.measurementTime)
        ) {
          auxequipmentInterMeasurement =
            auxequipmentInterMeasurement -
            selectedEquipment.channels[falseStateChannels[indexState]].measurement.measurementTime;
        }
      }
      if (parseFloat(selectedEquipment.measurementInfo.interval) < auxequipmentInterMeasurement) {
        newErrors[selectedEquipmentID + "_frequency"] = "not.higher.than.amount.measurement.time.channels";
      }
      setErrors(newErrors);
      setEquipmentInterMeasurement(suma);
      const newSubToggle = [];
      const newZoneToggle = [];

      const newChannelDataToggle = [];
      const newChannelDataToggle2 = [];
      for (let indexChannel = 0; indexChannel < selectedEquipment.channels.length; indexChannel++) {
        if (isNil(channelDataToggle) || isNil(channelDataToggle[indexChannel])) {
          newChannelDataToggle.push(false);
          newChannelDataToggle2.push(false);
        } else {
          newChannelDataToggle.push(channelDataToggle[indexChannel]);
          newChannelDataToggle2.push(channelDataToggle2[indexChannel]);
        }
        newSubToggle.push([]);
        newZoneToggle.push([]);
        for (let indexSub = 0; indexSub < selectedEquipment.channels[indexChannel].substructures.length; indexSub++) {
          if (isNil(subToggle[indexChannel]) || isNil(subToggle[indexChannel][indexSub])) {
            newSubToggle[indexChannel].push(false);
          } else {
            newSubToggle[indexChannel].push(subToggle[indexChannel][indexSub]);
          }
          newZoneToggle[indexChannel].push([]);
          for (
            let indexZone = 0;
            indexZone < selectedEquipment.channels[indexChannel].substructures[indexSub].zones.length;
            indexZone++
          ) {
            if (
              isNil(zoneToggle[indexChannel]) ||
              isNil(zoneToggle[indexChannel][indexSub]) ||
              isNil(zoneToggle[indexChannel][indexSub][indexZone])
            ) {
              newZoneToggle[indexChannel][indexSub].push(false);
            } else {
              newZoneToggle[indexChannel][indexSub].push(zoneToggle[indexChannel][indexSub][indexZone]);
            }
          }
        }
      }

      setChannelDataToggle(newChannelDataToggle); //Toggle para editar Información de Channels y Subs(Parte de Arriba)
      setChannelDataToggle2(newChannelDataToggle2); //Toggle para abrir unicamente los Collapses de Channels(Parte de Abajo)
      setSubToggle(newSubToggle); // Toggle para abrir Collapses de Subestructuras y editar cantidad de Zonas(Parte de Abajo)
      setZoneToggle(newZoneToggle); //Toggle para abrir Modal de Zonas y editar rangos y configuración de alertas(Parte de Abajo)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEquipment]);

  useEffect(() => {
    if (!isNil(currentUser)) {
      dispatch(getAssetsDataAction(currentUser.id));
      dispatch(getConfigDataAction());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  if (assets.loading || isNil(currentUser)) {
    return (
      <div
        style={{ height: "92vh", display: "flex", justifyContent: "center", alignItems: "center" }}
      >{`${intl.formatMessage({ id: "loading" })}...`}</div>
    );
  }

  return (
    <div style={{ width: "100%" }}>
      <div style={{ fontSize: "x-large", padding: "1rem", width: "100%" }}>
        {intl.formatMessage({ id: "asset.configuration" })}
      </div>
      <Box
        sx={{
          minHeight: 200,
          height: isNil(assets) || isEmpty(assets) ? 400 : "80vh",
          width: "100%",
          padding: "1rem",
          "& .actions": {
            color: palette.secondary,
          },
          "& .textPrimary": {
            color: palette.primary,
          },
          overflow: "auto",
        }}
      >
        {!isNil(selectedAsset) && (
          <div
            style={{
              border: `1px solid ${palette.primary}`,
              position: "relative",
              margin: "2rem 0 0 1rem",
              padding: "0 1rem 1rem 1rem",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "-2rem",
                backgroundColor: palette.likeWhite,
                padding: "0.2rem 0.4rem 0.2rem 0",
                left: "-1rem",
              }}
            >
              <TextField
                id="asset_to_configure"
                margin="dense"
                style={{ width: "10rem" }}
                variant="outlined"
                defaultValue={assets?.data?.[0]?.name}
                onChange={(e) => {
                  const selectedAssetName = e.target.value;
                  const newSelectedAsset = assets.data.find((asset) => asset.name === selectedAssetName);
                  setSelectedAsset(newSelectedAsset);
                  const assetSensIDs = [];
                  for (let index = 0; index < newSelectedAsset.config.additional_sensor.length; index++) {
                    assetSensIDs.push(newSelectedAsset.config.additional_sensor[index].sensor_ID);
                  }
                  setAssetSensors(assetSensIDs);
                  setEquipments(newSelectedAsset.equipments);
                  setRealState(true);
                  setSelectedEquipment(newSelectedAsset.equipments[0]);
                  setSelectedEquipmentID(newSelectedAsset.equipments[0].equipmentID);
                }}
                select
                label={intl.formatMessage({ id: "assets" })}
                required
              >
                {!isNil(assets.data) &&
                  assets.data.map((asset, index) => (
                    <MenuItem value={asset.name} key={asset.name + index}>
                      {asset.name}
                    </MenuItem>
                  ))}
              </TextField>
            </div>
            <div
              style={{
                border: `1px solid ${palette.primary}`,
                position: "relative",
                margin: "5rem 0 0 1rem",
                padding: "0 1rem 1rem 1rem",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-2rem",
                  backgroundColor: palette.likeWhite,
                  padding: "0.2rem 0.4rem 0.2rem 0",
                  left: "-1rem",
                }}
              >
                {!isNil(equipments) && !isEmpty(equipments) ? (
                  <TextField
                    id="equipment_to_configure"
                    margin="dense"
                    style={{ width: "10rem" }}
                    variant="outlined"
                    defaultValue={selectedEquipmentID}
                    value={selectedEquipmentID}
                    onChange={(e) => {
                      const selectedEquipmentIDOnChange = e.target.value;
                      const selectedEquipmentChange = equipments.find(
                        (equip) => equip.equipmentID === selectedEquipmentIDOnChange,
                      );
                      setRealState(true);
                      setSelectedEquipment(selectedEquipmentChange);
                      setSelectedEquipmentID(selectedEquipmentIDOnChange);
                    }}
                    select
                    label={intl.formatMessage({ id: "equipment" })}
                    required
                  >
                    {equipments.map((equipment, index) => (
                      <MenuItem value={equipment.equipmentID} key={equipment.equipmentID + index}>
                        {equipment.name}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : null}
              </div>

              {(currentUser.role === "total_admin" || currentUser.role === "administrator") &&
                !isNil(setSelectedEquipmentID) && (
                  <div style={{ fontSize: "x-large", marginTop: "3rem", width: "100%" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", margin: "0.5rem" }}>
                      {currentUser.role === "total_admin" && (
                        <>
                          {selectedEquipment.equipmentType === "DAS" ? (
                            <>
                              <TextField
                                id={selectedEquipmentID + "_spatialResolution"}
                                style={{ margin: "0 0.2rem" }}
                                value={selectedEquipment.spatialResolution}
                                onChange={(e) => {
                                  const newErrors = { ...errors };
                                  if (isEmpty(e.target.value)) {
                                    newErrors[e.target.id] = "not.empty";
                                  } else {
                                    delete newErrors[e.target.id];
                                  }
                                  setErrors(newErrors);
                                  const index = equipments.findIndex(
                                    (equipment) => equipment.equipmentID === selectedEquipmentID,
                                  );
                                  const newEquipments = [...equipments];
                                  const updatedEquipment = { ...newEquipments[index] };
                                  updatedEquipment.spatialResolution = parseFloat(e.target.value);
                                  newEquipments[index] = updatedEquipment;
                                  setRealState(false);
                                  setSelectedEquipment(updatedEquipment);
                                  setEquipments(newEquipments);
                                }}
                                error={errors[selectedEquipmentID + "_spatialResolution"] ? true : false}
                                variant="outlined"
                                label={intl.formatMessage({ id: "channel.spatial.resolution" })}
                                required
                                type="number"
                              ></TextField>
                              {!isNil(errors[selectedEquipmentID + "_spatialResolution"]) && (
                                <ErrorText>
                                  {intl.formatMessage({ id: errors[selectedEquipmentID + "_spatialResolution"] })}
                                </ErrorText>
                              )}
                              <TextField
                                id={selectedEquipmentID + "_criticalArea"}
                                style={{ margin: "0 0.2rem" }}
                                value={selectedEquipment.criticalArea.distance}
                                onChange={(e) => {
                                  const newErrors = { ...errors };
                                  if (isEmpty(e.target.value)) {
                                    newErrors[e.target.id] = "not.empty";
                                  } else {
                                    delete newErrors[e.target.id];
                                  }
                                  setErrors(newErrors);
                                  const index = equipments.findIndex(
                                    (equipment) => equipment.equipmentID === selectedEquipmentID,
                                  );
                                  const newEquipments = [...equipments];
                                  const updatedEquipment = {
                                    ...newEquipments[index],
                                    criticalArea: { ...newEquipments[index].criticalArea },
                                  };
                                  updatedEquipment.criticalArea.distance = parseFloat(e.target.value);
                                  newEquipments[index] = updatedEquipment;
                                  setRealState(false);
                                  setSelectedEquipment(updatedEquipment);
                                  setEquipments(newEquipments);
                                }}
                                error={errors[selectedEquipmentID + "_criticalArea"] ? true : false}
                                variant="outlined"
                                label={intl.formatMessage({ id: "critical.area" })}
                                type="number"
                                required
                              ></TextField>
                              {!isNil(errors[selectedEquipmentID + "_criticalArea"]) && (
                                <ErrorText>
                                  {intl.formatMessage({ id: errors[selectedEquipmentID + "_criticalArea"] })}
                                </ErrorText>
                              )}
                              <TextField
                                id={selectedEquipmentID + "_protecionArea"}
                                style={{ margin: "0 0.2rem" }}
                                value={selectedEquipment.protectionArea.distance}
                                onChange={(e) => {
                                  const newErrors = { ...errors };
                                  if (isEmpty(e.target.value)) {
                                    newErrors[e.target.id] = "not.empty";
                                  } else {
                                    delete newErrors[e.target.id];
                                  }
                                  setErrors(newErrors);
                                  const index = equipments.findIndex(
                                    (equipment) => equipment.equipmentID === selectedEquipmentID,
                                  );
                                  const newEquipments = [...equipments];
                                  const updatedEquipment = {
                                    ...newEquipments[index],
                                    protectionArea: { ...newEquipments[index].protectionArea },
                                  };
                                  updatedEquipment.protectionArea.distance = parseFloat(e.target.value);
                                  newEquipments[index] = updatedEquipment;
                                  setRealState(false);
                                  setSelectedEquipment(updatedEquipment);
                                  setEquipments(newEquipments);
                                }}
                                error={errors[selectedEquipmentID + "_protecionArea"] ? true : false}
                                variant="outlined"
                                label={intl.formatMessage({ id: "protection.area" })}
                                type="number"
                                required
                              ></TextField>
                              {!isNil(errors[selectedEquipmentID + "_spatialResolution"]) && (
                                <ErrorText>
                                  {intl.formatMessage({ id: errors[selectedEquipmentID + "_spatialResolution"] })}
                                </ErrorText>
                              )}
                              <Button
                                variant="contained"
                                id="area_button"
                                style={{
                                  padding: "0.2rem 0.5rem",
                                  backgroundColor: palette.primary,
                                  color: "white",
                                }}
                                onClick={async () => {
                                  const index = equipments.findIndex(
                                    (equipment) => equipment.equipmentID === selectedEquipmentID,
                                  );
                                  const newEquipments = [...equipments];
                                  const updatedEquipment = {
                                    ...newEquipments[index],
                                    criticalArea: { ...newEquipments[index].criticalArea },
                                    protectionArea: { ...newEquipments[index].protectionArea },
                                  };

                                  const criticalArea = updatedEquipment.criticalArea.distance;
                                  const protectionArea = updatedEquipment.protectionArea.distance;

                                  const critPolies = [];
                                  const protPolies = [];

                                  for (let indexPolyline = 0; indexPolyline < polylines.length; indexPolyline++) {
                                    const polys = await offsetPolygonPerSegment(
                                      polylines[indexPolyline],
                                      criticalArea,
                                      protectionArea,
                                      updatedEquipment,
                                      intl,
                                    );
                                    critPolies.push(polys.criticalCoords);
                                    protPolies.push(polys.protectCoords);
                                  }

                                  updatedEquipment.criticalArea.polygon = critPolies;
                                  updatedEquipment.protectionArea.polygon = protPolies;
                                  newEquipments[index] = updatedEquipment;
                                  setSelectedEquipment(updatedEquipment);
                                  setEquipments(newEquipments);
                                  toast.success(intl.formatMessage({ id: "polygon.calculated" }), {
                                    className: "toast-success",
                                  });
                                }}
                              >
                                {intl.formatMessage({ id: "calculate.area" })}
                              </Button>
                            </>
                          ) : (
                            <>
                              <TextField
                                id={selectedEquipmentID + "_frequency"}
                                style={{ margin: "0 0.2rem", width: "13%" }}
                                value={selectedEquipment.measurementInfo.interval}
                                inputProps={{ min: 0, max: 86400 }}
                                onChange={(e) => {
                                  setRealState(false);
                                  handleInterMeasurementTime({
                                    actualID: selectedEquipmentID + "_frequency",
                                    equipmentInterMeasurement,
                                    equipments,
                                    errors,
                                    setErrors,
                                    selectedEquipmentID,
                                    selectedEquipment,
                                    setSelectedEquipment,
                                    setEquipments,
                                    value: e.target.value,
                                    setEquipmentInterMeasurement,
                                  });
                                }}
                                type="number"
                                error={errors[selectedEquipmentID + "_frequency"] ? true : false}
                                variant="outlined"
                                label={intl.formatMessage({ id: "measure.frequency" })}
                                required
                              ></TextField>
                              {!isNil(errors[selectedEquipmentID + "_frequency"]) && (
                                <ErrorText>
                                  {intl.formatMessage({ id: errors[selectedEquipmentID + "_frequency"] })}
                                </ErrorText>
                              )}
                            </>
                          )}
                        </>
                      )}
                      {(currentUser.role === "total_admin" || currentUser.role === "administrator") && (
                        <>
                          <TextField
                            id={selectedEquipmentID + "_IP"}
                            style={{ margin: "0 0.2rem" }}
                            value={selectedEquipment.moreInfo.ipAddress}
                            onChange={(e) => {
                              const newErrors = { ...errors };
                              const regex =
                                /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                              const isValidInput = regex.test(e.target.value);
                              if (isEmpty(e.target.value)) {
                                newErrors[e.target.id] = "not.empty";
                              } else if (!isValidInput) {
                                newErrors[e.target.id] = "must.ip";
                              } else {
                                delete newErrors[e.target.id];
                              }
                              setErrors(newErrors);
                              const index = equipments.findIndex(
                                (equipment) => equipment.equipmentID === selectedEquipmentID,
                              );
                              const newEquipments = [...equipments];
                              const updatedEquipment = { ...newEquipments[index] };
                              updatedEquipment.moreInfo.ipAddress = e.target.value;
                              newEquipments[index] = updatedEquipment;
                              setRealState(false);
                              setSelectedEquipment(updatedEquipment);
                              setEquipments(newEquipments);
                            }}
                            error={errors[selectedEquipmentID + "_IP"] ? true : false}
                            variant="outlined"
                            label={intl.formatMessage({ id: "ip.address" })}
                            required
                          ></TextField>
                          {!isNil(errors[selectedEquipmentID + "_IP"]) && (
                            <ErrorText>{intl.formatMessage({ id: errors[selectedEquipmentID + "_IP"] })}</ErrorText>
                          )}
                          <LoadingButton
                            variant="contained"
                            size="large"
                            style={{
                              padding: "0.2rem 0.5rem",
                              backgroundColor: disabledPing ? palette.light : palette.primary,
                              color: "white",
                            }}
                            onClick={async () => {
                              const index = equipments.findIndex(
                                (equipment) => equipment.equipmentID === selectedEquipmentID,
                              );
                              const newEquipments = [...equipments];
                              const updatedEquipment = { ...newEquipments[index] };
                              setLoadingPing(true);
                              await pingIpAddress(selectedEquipmentID, updatedEquipment.moreInfo.ipAddress, intl);
                              setLoadingPing(false);
                            }}
                            loading={loadingPing ?? false}
                            disabled={disabledPing}
                          >
                            PING
                          </LoadingButton>
                        </>
                      )}
                    </div>
                  </div>
                )}
              {currentUser.role === "operator" && (
                <div style={{ fontSize: "x-large", marginTop: "2rem", width: "100%" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", margin: "0.5rem" }}></div>
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap", // 👈 permite múltiples filas
                  alignItems: "center",
                  gap: "0.5rem",
                  width: "100%", // 👈 para que use todo el ancho disponible
                  marginLeft: "0.3rem",
                }}
              >
                {!isNil(selectedEquipment) &&
                  selectedEquipment.channels.map((channel, indexChannel) => {
                    return (
                      <div key={indexChannel}>
                        {!isNil(channelDataToggle) && (
                          <>
                            <Button
                              variant="contained"
                              style={{
                                margin: "5%",
                                backgroundColor: palette.secondary,
                                width: "10rem",
                                color: "white",
                              }}
                              key={`openmodal${indexChannel}`}
                              onClick={() => {
                                let newChannel = clone(channelDataToggle);
                                if (newChannel[indexChannel]) {
                                  newChannel[indexChannel] = false;
                                } else {
                                  newChannel[indexChannel] = true;
                                  for (
                                    let indexChannelData = 0;
                                    indexChannelData < channelDataToggle.length;
                                    indexChannelData++
                                  ) {
                                    if (indexChannelData !== indexChannel) {
                                      newChannel[indexChannelData] = false;
                                    }
                                  }
                                }
                                setChannelDataToggle(newChannel);
                              }}
                            >
                              {selectedEquipment.channels[indexChannel].name} - {intl.formatMessage({ id: "channel" })}{" "}
                              {indexChannel + 1}
                            </Button>
                            <ThemeProvider theme={theme}>
                              <ChannelInfo
                                assetSensors={assetSensors}
                                channel={channel}
                                channelDataToggle={channelDataToggle}
                                channelsSensorsIDs={channelsSensorsIDs}
                                equipmentInterMeasurement={equipmentInterMeasurement}
                                equipments={equipments}
                                errors={errors}
                                indexChannel={indexChannel}
                                intl={intl}
                                selectedEquipment={selectedEquipment}
                                selectedEquipmentID={selectedEquipmentID}
                                setChannelDataToggle={setChannelDataToggle}
                                setEquipmentInterMeasurement={setEquipmentInterMeasurement}
                                setEquipments={setEquipments}
                                setErrors={setErrors}
                                setRealState={setRealState}
                                setSelectedEquipment={setSelectedEquipment}
                                setchannelSensorsIDs={setchannelSensorsIDs}
                                BootstrapButton={BootstrapButton}
                                setZoneToggle={setZoneToggle}
                                zoneToggle={zoneToggle}
                                polylines={polylines}
                                key={`channelModals${indexChannel}`}
                              />
                            </ThemeProvider>
                          </>
                        )}
                      </div>
                    );
                  })}
              </div>
              {!isNil(selectedEquipment) && !isNil(channelDataToggle2) && !isNil(currentConfig) && (
                <MeasurementInfo
                  channelToggle={channelDataToggle2}
                  setChannelToggle={setChannelDataToggle2}
                  setSubToggle={setSubToggle}
                  setZoneToggle={setZoneToggle}
                  subToggle={subToggle}
                  zoneToggle={zoneToggle}
                  equipments={equipments}
                  errors={errors}
                  selectedEquipment={selectedEquipment}
                  setEquipments={setEquipments}
                  setSelectedEquipment={setSelectedEquipment}
                  polylineDisplay={polylines}
                  setErrors={setErrors}
                  configData={currentConfig}
                  intl={intl}
                />
              )}
            </div>
            <LoadingButton
              variant="contained"
              size="large"
              style={{
                marginTop: "1rem",
                padding: "0.2rem 0.5rem",
                backgroundColor: disabled ? palette.light : palette.primary,
                color: "white",
              }}
              loading={loading ?? false}
              disabled={disabled}
              onClick={() => {
                updateData({
                  selectedAsset,
                  selectedEquipment,
                  channelsSensorsIDs,
                  alertTimeRange,
                  equipments,
                  setLoading,
                  dispatch,
                  assets,
                  role: currentUser.role,
                  currentUser,
                  intl,
                });
              }}
            >
              {intl.formatMessage({ id: "save" })}
            </LoadingButton>
          </div>
        )}
        {isNil(selectedAsset) && (
          <div
            style={{ height: "70vh", display: "flex", justifyContent: "center", alignItems: "center" }}
          >{`${intl.formatMessage({ id: "no.data" })}`}</div>
        )}
      </Box>
    </div>
  );
};

export default Configuration;
